// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_22LIL){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_1LS-o .dualColumn_3kYO6{display:flex;align-content:space-between}.nsAddressForm_1LS-o .dualColumn_3kYO6 .firstCol_ygYgV{margin-right:20px}.optional_3w-iU{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_22LIL",
	"nsAddressForm": "nsAddressForm_1LS-o",
	"dualColumn": "dualColumn_3kYO6",
	"firstCol": "firstCol_ygYgV",
	"optional": "optional_3w-iU"
};
module.exports = exports;
